import script from "./header.vue?vue&type=script&setup=true&lang=ts"
export * from "./header.vue?vue&type=script&setup=true&lang=ts"

import "./header.vue?vue&type=style&index=0&id=512602d9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512602d9"]])

export default __exports__